import React from 'react';

import styled from 'styled-components';

import { Login } from '@mui/icons-material';
import { Badge, Box, Paper } from '@mui/material';

import { IRoomState, RoomAgendaEvent, OccurrenceStatus } from './types/roomAgenda';
import { LiveBadgePill } from 'components/Badges/LiveBadgePill';
import Button from 'components/Button';
import Text from 'components/Text';
import { useUser } from 'global/UserContext';

const DisabledBadge = styled.div`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: ${({ theme }) => theme.COLORS.GRAY_80};
  color: ${({ theme }) => theme.COLORS.TEXT_SECONDARY};
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  event: RoomAgendaEvent | null;
  onEnterMeeting?: () => void;
  roomState: IRoomState | null;
  status: OccurrenceStatus;
}

const RoomEventActions: React.FC<Props> = ({ event, onEnterMeeting, roomState, status }) => {
  const isOnline = !!event?.local?.is_online;
  const { user } = useUser();
  console.log('roomEventActions EVENT', { event, status, user });

  const handleEnter = () => {
    // Hook up real navigation/open logic here when available
    console.log('[RoomEventActions] Enter event clicked', event?.id);
    onEnterMeeting?.();
  };

  const enterBtnLabel = event ? 'Entrar no Evento' : 'Entrar na Sala';
  const isOpen = roomState?.is_open;

  const mayEnter = status !== 'FINISHED';

  return (
    <Paper
      elevation={0}
      sx={{
        minWidth: '180px',
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.2) 100%)',
        // border: '1px solid rgba(255, 255, 255, 0.12)',
        borderRadius: '12px',
        overflow: 'visible',
      }}
    >
      <Text size="medium" bold>
        Ações
      </Text>

      {/* <DisabledBadge>
        <Text size="small">Inscrito!</Text>
      </DisabledBadge> */}

      {isOpen ? (
        <Badge
          color="default"
          badgeContent={<LiveBadgePill>LIVE</LiveBadgePill>}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={{
            display: 'block',
            width: '100%',
            '& .MuiBadge-badge': {
              right: 19,
              top: -3,
              background: 'transparent',
              boxShadow: 'none',
              padding: 0,
              minWidth: 'auto',
              height: 'auto',
              overflow: 'visible',
              pointerEvents: 'none',
            },
          }}
        >
          <Box sx={{ width: '100%', position: 'relative', overflow: 'visible' }}>
            <Button
              fullWidth
              size="small"
              variant="primary"
              onClick={handleEnter}
              icon={<Login />}
              disabled={!mayEnter}
            >
              {enterBtnLabel}
            </Button>
          </Box>
        </Badge>
      ) : (
        <Button
          fullWidth
          size="small"
          variant="primary"
          onClick={handleEnter}
          icon={<Login />}
          disabled={!mayEnter}
        >
          {enterBtnLabel}
        </Button>
      )}
    </Paper>
  );
};

export default RoomEventActions;
